import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString
} from '@/utils/checks'
import { RefinementList } from '@/domain/search/types'
import { TaxonomyFilters } from '@/types/models'

interface GenerateFacetFiltersFunction {
  (props: { refinementList?: RefinementList }): string[]
}

export const generateFacetFilters: GenerateFacetFiltersFunction = ({
  refinementList = {}
}) => {
  if (!isNonEmptyObject(refinementList)) {
    return []
  }

  const newFacets = Object.entries(refinementList)
    .map(([facet, term]) => {
      if (isNonEmptyString(term)) {
        return `${facet}:${term}`
      }

      if (!isNonEmptyArray(term)) {
        return ''
      }

      if (facet === TaxonomyFilters.locations && term.length > 1) {
        return `${facet}:${term.shift() || ''}`
      }

      return term
        .filter(Boolean)
        .map((t) => {
          return `${facet}:${t}`
        })
        .flat()
    })
    .filter(Boolean)
    .flat()

  return newFacets
}
